import { registerClientReference } from "react-server-dom-turbopack/server.edge";
export const ClientClerkProvider = registerClientReference(
    function() { throw new Error("Attempted to call ClientClerkProvider() from the server but ClientClerkProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/@clerk/nextjs/dist/esm/app-router/client/ClerkProvider.js",
    "ClientClerkProvider",
);
